module.exports = __webpack_public_path__ + "static/media/productivity-tool.069518a6.svg";